// extracted by mini-css-extract-plugin
export var carrierNotice = "_mb-5";
export var carrierNoticePlaceholder = "_mb-6";
export var deliveryRow = "_mb-c";
export var fixedHeight = "_mb-4";
export var freightLogo = "_mb-b";
export var fullWidth = "_mb-3";
export var priceColumn = "_mb-7";
export var radioSelected = "_mb-9";
export var radioUnselected = "_mb-8";
export var selectedOption = "_mb-2";
export var selectedOptionContainer = "_mb-1";
export var selection = "_mb-0";
export var tallSkeletonText = "_mb-a";